import { BLACK } from 'constants/colours';

export default {
  iconColour: BLACK,
};



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.style.js